import { useSyncExternalStore } from "react";
import { onSessionEnd } from "@/auth/session";
import { DATA_BASE_URL, DATA_PUBLIC_URL } from "@/config/api";
import { apiFetch } from "./api-client";
import { createDataAccess, type DataAccessProblem } from "./data-access";

/**
 * The app's data.mdf.lu client: every Digital Twin file request goes through
 * dataFetch(), which brings the signed cookies along (see data-access.ts).
 */
const dataAccess = createDataAccess({
  // credentials: the browser keeps the cookies the API sets for .mdf.lu.
  issue: () => apiFetch("/v1/data-access", { method: "POST", credentials: "include" }),
  fetch: (...args) => fetch(...args),
  dataBaseUrl: () => DATA_BASE_URL,
  publicBaseUrl: DATA_PUBLIC_URL,
});

onSessionEnd(() => dataAccess.reset());

export const dataFetch = dataAccess.dataFetch;

/** Why map data could not be loaded (null: all fine); re-renders on change. */
export function useDataAccessProblem(): DataAccessProblem | null {
  return useSyncExternalStore(dataAccess.onProblemChange, dataAccess.getProblem);
}
